import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    /*
      Consulta das rematrículas feitas pelo RESPONSÁVEL no portal, com a 2ª via do recibo.

      A rematrícula em si não tem rota: ela acontece num card da Home do responsável, e quem a
      libera é a janela configurada no cadastro da escola (GesParametros 59 e 60). O que precisa
      de permissão é esta tela — o lado da escola.

      A permissão é PRÓPRIA (300200302), vizinha da rematrícula em lote do legado (300200300), e
      não reaproveitada: quem opera o lote não é necessariamente quem atende a família no balcão
      pedindo a segunda via. Ver `consultebase/scripts/2026-09-17-Permissao-RematriculasResponsavel.sql`.
    */
    description: 'Rematrículas do Responsável',
    path: '/academico/rematriculas_responsavel',
    name: 'rematriculas_responsavel',
    component: () => import('@/views/academico/rematriculasresponsavel/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.REMATRICULASRESPONSAVELNOVO_MENU_300200302],
    },
    goesToMenu: true,
  },
];
